import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';
import AppStore from './stores/AppStore';
import createBrowserHistory from 'history/createBrowserHistory';
import {Provider} from 'mobx-react';
import {Router} from 'react-router';
import {RouterModel, syncHistoryWithStore} from 'mst-react-router';
import {isTokenExpired} from './lib/jwt';
import localStore from 'store';

const router = RouterModel.create();
const token = localStore.get('token');
const appStore = AppStore.create({router, auth: {authenticated: !isTokenExpired(token)}});
const history = syncHistoryWithStore(createBrowserHistory(), router);

window.store = appStore;

ReactDOM.render(
  <Provider store={appStore}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root')
);
registerServiceWorker();
